import { type FC, Fragment, useMemo } from 'react';

import { cn } from '~/lib/cn';
import { ArtistsList } from '~/modules/global-search/ArtistsList.tsx';
import { EmptyResult } from '~/modules/global-search/EmptyResult.tsx';
import { RecordLabelsList } from '~/modules/global-search/RecordLabelsList.tsx';
import { ToolsList } from '~/modules/global-search/ToolsList.tsx';
import { TracksList } from '~/modules/global-search/TracksList.tsx';
import type { LinkItemProps } from '~/modules/link-farm/components/LinkList/LinkItem.tsx';

export type GlobalSearchResultProps = {
  searchValue?: string;
  visible?: boolean;
  items: {
    tools?: LinkItemProps[];
    label?: string[];
  };
};

export const GlobalSearchResult: FC<GlobalSearchResultProps> = ({
  visible,
  searchValue,
  items,
}) => {
  const isEmptyResult = useMemo(
    () => !Object.values(items).find((item) => item?.length),
    [items],
  );

  return (
    <div className={cn('w-full', (!searchValue || !visible) && 'hidden')}>
      <div
        role="listbox"
        aria-live="polite"
        className="flex flex-col absolute w-full mt-xs z-50 bg-level-02 rounded-sm py-lg px-md gap-md overflow-auto max-h-[80dvh]"
      >
        {isEmptyResult ? (
          <EmptyResult />
        ) : (
          <Fragment>
            <ArtistsList items={[]} />
            <TracksList items={[]} />
            <RecordLabelsList items={[]} />
            <ToolsList items={items.tools ? ['empty'] : []} />
          </Fragment>
        )}
      </div>
    </div>
  );
};

GlobalSearchResult.displayName = 'GlobalSearchResult';
